"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themes = void 0;
const outline_1 = require("@heroicons/react/outline");
exports.themes = {
    contentBox: {
        layouts: {
            card: {
                container: {
                    shared: 'z-10 flex flex-col bg-content-background rounded-content shadow-content relative border-content border-content-border',
                    states: {
                        resizing: 'outline-offset-2 outline-dashed outline-2 outline-accent-500 resize-y',
                    },
                },
                header: {
                    shared: 'p-4 sm:p-6 rounded-t-content relative',
                    variants: {
                        default: 'border-b border-content-separator',
                        tabbed: 'pb-0 sm:pb-0 transition-color',
                        performances: 'border-b border-misc-200',
                    },
                    states: {
                        linked: 'transition hover:bg-content-background-hover',
                    },
                    inner: 'flex items-center gap-3 justify-between flex-wrap sm:flex-nowrap',
                },
                resize: {
                    button: 'w-full border-t border-misc-200 flex justify-center py-2',
                    icon: {
                        icon: outline_1.MenuAlt4Icon,
                        text: 'text-secondary-500',
                    },
                },
            },
            'no-card': {
                container: {
                    shared: 'flex flex-col',
                    states: {
                        resizing: 'outline-offset-2 outline-dashed outline-2 outline-accent-500 resize-y',
                    },
                },
                header: {
                    shared: 'relative',
                    variants: {
                        default: 'border-b border-content-separator',
                        tabbed: 'pb-0 sm:pb-0 transition-color',
                        performances: 'border-b border-misc-200',
                    },
                    states: {
                        linked: 'transition ',
                    },
                    inner: 'flex items-center gap-3 justify-between flex-wrap sm:flex-nowrap',
                },
                resize: {
                    button: 'w-full border-t border-misc-200 flex justify-center py-2',
                    icon: {
                        icon: outline_1.MenuAlt4Icon,
                        text: 'text-secondary-500',
                    },
                },
            },
        },
    },
    contentBoxTitle: {
        layouts: {
            card: {
                states: {
                    linked: {
                        icon: {
                            icon: outline_1.ArrowRightIcon,
                            layer: 'inline-block relative ',
                        },
                    },
                },
            },
            'no-card': {
                states: {
                    linked: {
                        icon: {
                            icon: outline_1.ArrowRightIcon,
                            layer: 'inline-block ms-1.5 relative -top-[2px]',
                        },
                    },
                },
            },
        },
    },
    contentBoxFunctionBar: {
        layouts: {
            card: {
                shared: 'bg-functionbar-background px-6 sm:px-6 py-3 text-sm',
                positions: {
                    top: 'border-b border-functionbar-border',
                    bottom: 'mt-auto border-t border-functionbar-border rounded-b-content',
                },
            },
            'no-card': {
                shared: 'bg-body px-6 sm:px-6 py-3 text-sm',
                positions: {
                    top: 'border-b border-functionbar-border',
                    bottom: 'mt-auto border-t border-functionbar-border rounded-b-content',
                },
            },
        },
    },
};
//# sourceMappingURL=themes.js.map